
export default {
  placeInput: {
    findAPlace: 'Ort finden',
    place: 'Ort',
    addRouteStop: 'Wegpunkt hinzufügen',
    routePlace: 'Wegpunkt',
    routeDestination: 'Ziel',
    placeNameRequired: 'Ortsname benötigt',
    yourLocation: 'Mein Standort',
    couldNotDetermineYourLocation: 'Standort konnte nicht ermittelt werden. Stellen Sie sicher, dass Sie ihrem Browser die erforderlichen Berechtigungen erteilt haben',
    useYourLocation: 'Meinen Standort nutzen',
    removeInput: 'Ort/Eingabe löschen',
    directions: 'Wegbeschreibung',
    fromYourBrowser: 'Von deinem Browser',
    addStartingPlace: 'Startpunkt hinzufügen',
    startingPlace: 'Startpunkt',
    openInputOptions: 'Eingabeoptionen öffnen',
    addInput: 'Ortseingabe hinzufügen',
    switchCoords: 'Koordinaten vertauschen',
    rawCoordinate: 'Lat,Long Koordinaten',
    fillOrRemoveInput: 'Suche ein Ort oder benutzen Sie die Karten-Schaltfläche auf der rechten Seite',
    noPlaceFound: 'Keine Orte gefunden',
    unknownSearchPlaceError: 'Unbekannter Fehler beim Suchen',
    approximateDistance: 'Ungefähre Entfernung in einer geraden Linie vom aktuellen Kartenzentrum',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'Es war nicht möglich, Ihren Standort zu bestimmen. Ihr bisheriger Standort wird stattdessen verwendet.',
    pleaseTypeSomething: 'Bitte geben Sie etwas ein, um zu suchen',
    toggleDirect: 'Direkter Weg (Luftlinie) zu nächstem Punkt an/aus',
    clickOnTheMapToSelectAPlace: 'Klicke auf die Karte um einen Ort auszuwählen',
    clickOnTheMapBtnToPickAPlace: 'Diesen Button klicken um einen Ort auf der Karte auszuwählen',
    goToDirectionsMode: 'Klicke den Routenplaner button um zum Routing-Modus zu wechseln',
    clickToSearchAndShowResultsOnTheMap: 'Hier klicken um zu Suchen und die Ergebnisse auf der Karte anzuzeigen'
  }
}
